module.exports = __webpack_public_path__ + "9f5da7e4f3740840b280e076f68c8b11.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SN.svg
// module id = mNNN
// module chunks = 0